/*
 * Il prezzo della barra sticky uguale a quello della scheda.
 *
 * Perche': lo sconto automatico Regios non sta nel prezzo del prodotto,
 * l'app lo scrive dopo il caricamento solo nel prezzo principale della scheda
 * (#price-<sezione>). La barra sticky stampa un suo prezzo (price.liquid con
 * use_variant) che l'app non tocca, e al cambio variante
 * sticky-atc-bar-minimalist.js lo riscrive dai dati della variante: in
 * entrambi i casi restava il prezzo pieno.
 *
 * Come: si copia il contenuto del prezzo principale in quello della barra,
 * con le classi di stato (in saldo, esaurito), senza f-price--large che e'
 * solo della scheda. Nessun conto qui: si mostra esattamente il prezzo che
 * il cliente vede sopra, sconto Regios compreso. Un MutationObserver rifa' la
 * copia quando l'app o il cambio variante riscrivono l'uno o l'altro; dopo la
 * copia i due sono uguali e la passata successiva non scrive niente.
 */
(() => {
  'use strict';

  if (window.StickyAtcPrice) return;

  const BAR = '.sticky-atc-bar[data-section]';
  const TARGET = '.sticky-atc-bar__product-info .f-price';
  const MAIN_ONLY_CLASSES = ['f-price--large'];

  const sync = () => {
    document.querySelectorAll(BAR).forEach((bar) => {
      const source = document.querySelector(`#price-${CSS.escape(bar.dataset.section)} .f-price`);
      const target = bar.querySelector(TARGET);
      if (!source || !target) return;

      const className = Array.from(source.classList)
        .filter((name) => !MAIN_ONLY_CLASSES.includes(name))
        .join(' ');

      if (target.className !== className) target.className = className;
      if (target.innerHTML !== source.innerHTML) target.innerHTML = source.innerHTML;
    });
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      sync();
    });
  };

  const start = () => {
    if (!document.querySelector(BAR)) return;
    sync();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class']
    });
  };

  window.StickyAtcPrice = { sync };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
